import defaultReducerLogic from './defaultReducerLogic'
import selectionCheckboxesReducer from './selectionCheckboxes'
import endingUnstyledReducer from './endingUnstyled'

export default function(state, action){
  state = defaultReducerLogic(state, action)
  state = selectionCheckboxesReducer(state, action)
  state = endingUnstyledReducer(state, action)
  return state
}


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/editorReducer/editorReducer.js